// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"relevantcard_wrapper__3ABap","imgwrapper":"relevantcard_imgwrapper__bUtBh","votewrapper":"relevantcard_votewrapper__2GmVM","checkbox":"relevantcard_checkbox__2Xh1Q"};